





























































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import scrollLock from 'scroll-lock';
import VueDraggableResizable from 'vue-draggable-resizable';
import 'vue-draggable-resizable/dist/VueDraggableResizable.css';
import { IFieldPosition } from '@/dealroom/fields/types/field-position';
import { IField } from '@/dealroom/fields/types/field';
import { EFieldAxis } from '@/dealroom/fields/types/enums/field-axis';
import { EFieldType } from '@/dealroom/fields/types/enums/field-type';
import { FieldHelper } from '@/dealroom/fields/helpers/field.helper';

@Component({
  components: {
    VueDraggableResizable,
  },
})
export default class FieldContainer extends Vue {
  @Prop() field!: IField;
  @Prop() isCheckbox: boolean;
  @Prop() pageWidth: number;
  @Prop() focused: boolean;

  @Prop({ default: true }) resizable: boolean;
  @Prop({ default: true }) parent: boolean;
  @Prop({ default: false }) highlighted: boolean;
  @Prop({ default: false }) showCoordinateBox: boolean;
  @Prop({ default: false }) locked: boolean;
  @Prop({ default: false }) isActive: boolean;
  @Prop({ default: false }) preventDeactivation: boolean;

  EFieldType = EFieldType;
  position: IFieldPosition = { ...this.field.position };
  axis: string = EFieldAxis.Both;

  @Watch('field', { deep: true })
  watchingField(newValue: IField) {
    this.position = { ...newValue.position };
  }

  handleHover(isHovered: boolean) {
    this.$emit('isHovered', isHovered);
  }

  get fieldType(): EFieldType {
    return this.field.type;
  }

  get classNames(): string {
    let classNames = 'field-container';
    if (this.focused) {
      classNames += ' focused';
    }
    if (this.isActive) {
      classNames += ' active';
    }
    if (this.field.isLoading) {
      classNames += ' disabled';
    }
    if (this.highlighted) {
      classNames += ' highlighted';
    }
    return classNames;
  }

  get minWidth(): number {
    const ratio: number = FieldHelper.getPageRatio(this.pageWidth);
    return 30 * ratio;
  }

  get minHeight(): number {
    const ratio: number = FieldHelper.getPageRatio(this.pageWidth);
    return 15 * ratio;
  }

  get fontSize(): string {
    return this.field.type !== EFieldType.Check
      ? `${(this.position.height * 0.6).toFixed(1)}px`
      : '';
  }

  get positionX(): number {
    return this.position.left;
  }

  get positionY(): number {
    return this.position.top;
  }

  get fieldWidth(): number {
    return this.position.width;
  }

  get fieldHeight(): number {
    return this.position.height;
  }

  get sourceClass(): string {
    return FieldHelper.getSourceClass(this.field.source);
  }

  get isTouchEnabled() {
    return (
      'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0
    );
  }

  get validatedInput(): boolean {
    return FieldHelper.getValidatedInput(this.field);
  }

  getHandles(isCheckbox: boolean): string[] {
    if (isCheckbox) {
      return [];
    }
    return ['tl', 'tm', 'tr', 'mr', 'br', 'bm', 'bl', 'ml'];
  }

  handleActivate(field: IField) {
    this.$emit('activate', field);
  }

  handleDeactivate(field: IField) {
    this.$emit('deactivate', field);
  }

  handleDragStop(left: number, top: number) {
    if (this.locked) {
      return;
    }
    scrollLock.clearQueueScrollLocks();
    scrollLock.enablePageScroll();
    if (this.positionX === left && this.positionY === top) {
      return;
    }
    this.position = { ...this.position, left, top };
    this.save();
  }

  handleResizing(top: number, left: number, width: number, height: number) {
    this.position = { top, left, width, height };
    this.$emit('isResizing', height);
  }

  handleResizeStop(left: number, top: number, width: number, height: number) {
    if (this.locked) {
      return;
    }
    this.$emit('isResizing', height);
    if (
      this.positionX === left &&
      this.positionY === top &&
      this.fieldHeight === height &&
      this.fieldWidth === width
    ) {
      return;
    }
    this.position = {
      left,
      top,
      width,
      height,
    };
    this.save();
  }

  handleDragging() {
    if (this.isTouchEnabled) {
      scrollLock.disablePageScroll();
    }
  }

  onDragStartCallback(ev: MouseEvent) {
    if (ev.shiftKey) {
      this.axis = EFieldAxis.X;
    } else {
      this.axis = EFieldAxis.Both;
    }
  }

  save() {
    this.$emit('save', { ...this.field, position: this.position });
  }

  mounted() {
    this.position = { ...this.field.position };
  }
}
